import { Component, OnInit } from '@angular/core';
import { IDatePickerConfig } from 'mis-crystal-design-system/datepicker_v2';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DateUtils } from 'src/app/utils/days-utils';

@Component({
  selector: 'app-attendance-card',
  templateUrl: './attendance-card.component.html',
  styleUrls: ['./attendance-card.component.scss']
}) 
export class AttendanceCardComponent implements OnInit {
  imgSrc: string;
  constructor(private envService: EnvironmentService) { }
   currentDate = DateUtils.formatCurrentDate("MMM DD, YYYY");

  selectedDate=this.currentDate
  startDatepickerConfig: Partial<IDatePickerConfig> = {
    maxDate:DateUtils.formatCurrentDate("MMM DD, YYYY"),
    format: 'MMM DD, YYYY',
  };
  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
  }
 
  changeFormat1(a:any)
  {
    this.selectedDate=a
 
  }
}
